import { GET, POST, PUT } from "./_config";

//user
export const getFaqData = async () => await GET("/faq");

//admin
export const getFaqDataList = async (query) =>
  await GET(`/faq/get-faq?${query || ""}`, true);

export const updateFaqStatus = async (body) =>
  await PUT("/faq/update-status", body, true);

export const deleteFaqDataById = async (body) =>
  await POST(`/faq/delete-data`, body, true);

export const createFaqData = async (body) =>
  await POST("/faq/add-faq", body, true);

export const getFaqDataById = async (id) => await GET(`/faq/${id}`, true);

export const updateFaqDataById = async (id, body) =>
  await PUT(`/faq/update-faq/${id}`, body, true);
